import React from 'react';
import { getReactionCustomImageUrl } from './messageReactions';

export function ReactionGlyph({ emoji, className }) {
  const src = getReactionCustomImageUrl(emoji);
  return (
    <span
      className={className}
      aria-hidden="true"
      onContextMenu={(e) => e.preventDefault()}
    >
      {src ? (
        <img
          src={src}
          alt=""
          draggable={false}
          onDragStart={(e) => e.preventDefault()}
          onContextMenu={(e) => e.preventDefault()}
        />
      ) : emoji}
    </span>
  );
}
